<template>
	{{{dadosconteudo.conteudo}}}
</template>
<script>
	export default{
		data(){
			return{
				dadosconteudo:{}
			}
		},
		ready(){

                var self = this;
                //json com os dados do menu
                
					var urlAtual = window.location.href.split('/');
					var covid = false
					
					for(var c = 0;c < urlAtual.length; c++){
						if(urlAtual[c] == 'covid') {
							covid = true
						}
					}

					var options = {
						covid: covid
					}
					
                $.getJSON('./server/paginainicial.php', options, function(links)
                	{                
                    	self.dadosconteudo = links[0];
                        //console.log(self.dadosconteudo)
                });
		}	
	}
</script>


// WEBPACK FOOTER //
// home.vue?76d4045c